import SingleTeamCard from "../components/SingleTeamCard";
import TeamData from "../json/data-team.json";
import Flicking, { ViewportSlot } from "@egjs/react-flicking";
import { useState } from "react";
import { Pagination, Perspective } from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/pagination.css";
import "@egjs/react-flicking/dist/flicking.css";
import '../assets/css/Home.css';
import SingleProjectCardHome from "../components/SingleProjectCardHome";
import Data from "../json/data.json";
import Slider from "react-slick"; // Importa el componente
import "slick-carousel/slick/slick.css"; // Importa estilos básicos
import "slick-carousel/slick/slick-theme.css";

const Home = () => {
  
const plugins = [new Pagination({ type: 'bullet' }),new Perspective({ rotate: 0.5 })];
const [msg, setMsg] = useState('');
const Submit = (e) => {
  setMsg("processing email ...")
  const form = document.getElementById("homeContactForm");
  const scriptURL = 'https://script.google.com/macros/s/AKfycby5koZey_9O1-uuq2QyKkp-wzuJaYZ9DyqLYev-tMdWrrVuycmdjtF_QyUGbph84OH-GQ/exec';
    e.preventDefault()
    let data = new FormData(form)
    fetch(scriptURL, { method: "POST", body: data})
      .then(res=>res.text())
      .then(data => setMsg(data))
  document.getElementById('name').value="";
  document.getElementById('msgform').value="";
  document.getElementById('email').value="";
  //const [ProjectsData];
}

    return (
      <div className="content-container">
        {/*HERO*/}
        <div className="bg-hero">
        <section id="home-hero" className="row">
            <div className="col-left-hero">
              <h3>Passion.</h3>
              <h3>Innovation.</h3>
              <h3>Precision.</h3>
              <div className="line"></div>
              <p>We are a dedicated team of Game Designers, Developers,
                and Artists passionate about creating immersive gaming
                experiences. Combining creativity with cutting-edge
                blockchain technology, we turn ideas into unforgettable
                adventures, delivered on time, every time. Let's build
                something extraordinary together.</p>
            </div>
            <div className="col-right-hero">
              <img alt="hero illustration" src={"/images/home/home-hero.png"} className="heroIllus"/>
            </div>
          </section>
          <section className="backer-logos">
          <div className="backer-logos-container">
            <img alt="cartoon network" src={"/images/logos/CN.png"} className="backer-logo"/>
            <img alt="comedy central" src={"/images/logos/comedyCentral.png"} className="backer-logo"/>
            <img alt="disney" src={"/images/logos/disney.png"} className="backer-logo"/>          
            <img alt="lego" src={"/images/logos/lego.png"} className="backer-logo"/>
            <img alt="mattel" src={"/images/logos/mattel.png"} className="backer-logo"/>
            <img alt="nick" src={"/images/logos/nickelodeon.png"} className="logo-chorizo"/>
            <img alt="rolling stones" src={"/images/logos/rollingStone.png"} className="logo-chorizo"/>
            <img alt="southpark" src={"/images/logos/southpark.png"} className="backer-logo"/>
            <img alt="shell" src={"/images/logos/shell.png"} className="backer-logo"/>
          </div>
        </section>
        </div>
        {/*THREE CARDS*/}
        <section id="project-section">
          <div className="project-categories-home-container">
            <div className="single-project-categories-home col_1-3 card1">
              <img alt="see more" src={"/images/icons/Icon_1.png"} className="category-icon"/>
              <h6>Crypto</h6>
              <p>We fuse our deep passion for gaming
              with advanced blockchain technology
              to help pioneer the evolving Web 3.0
              gaming landscape as co-creators.</p>
            </div>
            <div className="single-project-categories-home col_1-3 card2">
              <img alt="see more" src={"/images/icons/Icon_2.png"} className="category-icon"/>
              <h6>Education</h6>
              <p>Our games encourage learning
              through engaging and entertaining
              experiences. We design interactive
              journeys where every challenge
              overcome leads to newfound
              knowledge.</p>
            </div>
            <div className="single-project-categories-home col_1-3 card3">
              <img alt="see more" src={"/images/icons/Icon_3.png"} className="category-icon"/>
              <h6>Services</h6>
              <p>We understand your IP and know
              how to craft an interactive universe
              around it, backed by our global
              experience creating games and
              metaverses for leading brands.</p>
            </div>
          </div>
        </section>
        {/*PROJECTS*/}
        <div className="bg-projects">
          <section id="meet-our-projects">
              <div className="title-centered">
                <h3>Projects</h3>
              </div>
              <div className="team-container">
                <Slider 
                  dots={false} 
                  infinite={true} 
                  speed={500} 
                  slidesToShow={1} 
                  slidesToScroll={1}
                >
                   {
                      Data.map((project)=>{
                        return <div className="panel">
                        <SingleProjectCardHome 
                            key={project.id}
                            project={project}
                        /></div>
                      } )
                    }
                </Slider>
              </div>
          </section>
        </div>
        {/*TEAM*/}
        <div className="bg-team">
          <section id="meet-our-team">
            <div className="title-centered">
                <h3>Team</h3>
            </div>
            
            <div className="team-container">
              <Flicking
                key="slider2"
                dots={true}
                plugins={plugins}
                circular={true}
                onMoveEnd={e => {
                  console.log(e);
                }}>
                  {
                    TeamData.map((member)=>{
                      return <div className="panel"><SingleTeamCard key={member.id} member={member} /></div>
                    } )
                  }
                <ViewportSlot>
                  <div className="flicking-pagination"></div>
                </ViewportSlot>
              </Flicking>
            </div>
          </section>
        </div>
        {/*CONTACT*/}
        <div className="bg-contact">
            <div className="title-centered">
                <h3>Contact</h3>
            </div>
          <section id="contact">
            {msg !== '' ? <h4 className="error-msg">{msg}</h4> : null}
            
            <form id="homeContactForm" onSubmit={(e)=>{Submit(e)}}>
              <div className="form-inputs">
                  <input id="name" type="text" name="name" placeholder="Name:" />
                  <input id="email" type="email" name="email" placeholder="Email:" />
              </div>
              <textarea id="msgform" name="message" placeholder="Tell us your needs:" />
              <div className="submit-container">
                <input type="submit" value="SEND" className="orange-button" />
              </div>
            </form>
          </section>
        </div>
      </div>
    )

  };
  
  export default Home;